/**
 * REBUY MOBILE CHECKOUT FIX - CLEAN VERSION
 * Simple mobile checkout fix for Rebuy cart
 */

(function() {
  'use strict';

  // Mobile detection
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
           window.innerWidth <= 768 || 
           ('ontouchstart' in window);
  }

  // Simple checkout function
  function forceCheckout() {
    try {
      // Try Rebuy checkout first
      if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.checkout) {
        window.Rebuy.Cart.checkout();
        return;
      }
      
      // Fallback to direct checkout
      window.location.href = '/checkout';
    } catch (e) {
      window.location.href = '/checkout';
    }
  }

  // Setup for mobile only
  function setupMobileCheckout() {
    if (!isMobile()) return;

    // Intercept checkout button clicks on mobile
    document.addEventListener('click', function(e) {
      const target = e.target;
      const checkoutButton = target.closest('[data-force-checkout="true"]') || 
                            target.closest('.rebuy-cart__checkout-button') ||
                            target.closest('#rebuy-checkout-btn');
      
      if (checkoutButton && !checkoutButton.disabled) {
        e.preventDefault();
        e.stopPropagation();
        forceCheckout();
      }
    }, true);

    // Touch events for mobile
    document.addEventListener('touchend', function(e) {
      const target = e.target;
      const checkoutButton = target.closest('[data-force-checkout="true"]') || 
                            target.closest('.rebuy-cart__checkout-button') ||
                            target.closest('#rebuy-checkout-btn');
      
      if (checkoutButton && !checkoutButton.disabled) {
        e.preventDefault();
        e.stopPropagation();
        forceCheckout();
      }
    }, true);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileCheckout);
  } else {
    setupMobileCheckout();
  }

  // Reinitialize on Rebuy events
  document.addEventListener('rebuy:cart:opened', setupMobileCheckout);
  document.addEventListener('rebuy:cart:updated', setupMobileCheckout);

})(); 